import React from "react";
import ConfigRouter from "./ConfigRouter";
import LoadingIndicator from "./globals/Components/Loading/LoadingIndicator";
import { ConfigProvider, theme } from 'antd';
import esES from 'antd/locale/es_ES';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import * as pdfjsLib from 'pdfjs-dist';
import HelmetIndex from "./globals/HelmetIndex/HelmetIndex";
import { applyThemePreference, getThemePreference, subscribeThemePreference, ThemeMode } from "./services/themePreference";


// Configurar la ubicación del worker
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

interface AppState {
  themeMode: ThemeMode;
}

class App extends React.Component<{}, AppState> {
  private unsubscribeTheme?: () => void;

  state: AppState = {
    themeMode: getThemePreference()
  };

  componentDidMount() {
    applyThemePreference(this.state.themeMode);
    this.unsubscribeTheme = subscribeThemePreference((themeMode) => {
      this.setState({ themeMode });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribeTheme) {
      this.unsubscribeTheme();
    }
  }

  render() {
    const isDarkMode = this.state.themeMode === 'dark';

    return (
      <>
        <ConfigProvider
          locale={esES}
          theme={{
            algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
            token: {
              colorPrimary: '#2177f5',
              borderRadius: 8,
            },
          }}
        >
        <HelmetIndex />
          <ConfigRouter />
          <LoadingIndicator />
        </ConfigProvider>

      </>
    );
  }
}
export default App;
